import { IHintShortcutData } from '@shared/dto/hint_shortcuts/i_hint_shortcut_data';
import { ViewHintShortcutIcons } from '../shortcut_hint/ViewHintShortcutIcons';

interface Props {
  hint_data: IHintShortcutData;
}
export const ViewAllHintsShortcutsGroupItem = ({ hint_data }: Props) => {
  let { data_rows, keys_have_same_animation_delay } = hint_data;

  /*
   * EVENTS
   */

  /*
   * EFFECTS
   */

  /*
   * RENDERS
   */

  function render_hints() {
    return data_rows.map((item, index) => {
      let { mouse_data, keys } = item;

      return (
        <div key={`${item.text}_${index}`} id={`${item.text}_${index}`} className="min-h-[30px] max-h-[30px] gap-5 w-full flex items-center justify-between ">
          <ViewHintShortcutIcons {...{ index, mouse_data, keys, keys_have_same_animation_delay }} disable_keyboard_animation={true} />
          <span className="text-[14px] text-page-foreground">{item.text}</span>
        </div>
      );
    });
  }

  /*
   * HTML
   */

  return <>{render_hints()}</>;
};
